function toggleFilter() {
    let x = document.querySelector(".sq-filter-main");
    let y = document.querySelector(".sq-app");
    x.classList.toggle("opening");
    y.classList.toggle("opening");
}
function toggleClass() {
    let x = document.querySelector(".sq-filter-main");
    let y = document.querySelector(".sq-app");
    y.classList.remove("opening");
    x.classList.remove("opening");
}
function removeClass() {
    let x = document.querySelector(".sq-filter-main");
    let z = document.querySelector(".sq-app");
    x.classList.remove("opening");
    z.classList.remove("opening");
}

window.sq = window.sq || {};


window.sq.initSearch = (store) => {
    store.search();
};

window.sq.cart =()=>{
    setTimeout(()=>{
        document.querySelector("cart-drawer").classList.add("animate");
        document.querySelector("cart-drawer").classList.add("active");
    },500)
}

setTimeout(()=>{
    if(document.querySelector(".sq-filter-main")) document.querySelector(".sq-filter-main").style.visibility = null;
    if(document.querySelector(".sparq-container")) document.querySelector(".sparq-container").style.visibility = null;
},200)

